import React, { useState, useCallback, useRef } from "react";
import "./index.scss";
import moment from "moment";
import { BASE_URL } from "constants/routes";
import { useSelector } from "react-redux";
import VideoViewer from "../VideoViewer";

const LivenessDetection = (props) => {
  const {
    input_fields,
    label: document_label,
    selectedData,
    name: document_name,
    isMapper,
    documentData,
    form_field_items,
    recursive_section,
    recursive_Data,
  } = props;
  const currentSubWorkFlowId = useSelector(
    (state) => state?.dashboardDetailReducer?.currentSubWorkFlowId
  );
  const [currentTime, setCurrentTime] = useState(0);
  let videoSrc = "";
  let videoObject = {};
  let videoUrl = "";
  let downloadUrl = "";
  let isPdf = false;
  const label = isMapper ? documentData?.field_label : document_label;
  let name = isMapper ? documentData?.field_label : document_name;
  const applicationStatus = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo?.status
  );
  let videoEle = document.getElementById("livenessVideo");
  let playBtn = document.querySelector(".btn-play");

  if (name) {
    if (isMapper) {
      videoObject = documentData || {};
    } else if (recursive_section) {
      videoObject = recursive_Data[name];
    } else {
      videoObject = selectedData?.documents && selectedData?.documents[name];
    }

    if (
      videoObject?.encrypted_filename &&
      currentSubWorkFlowId &&
      !recursive_section
    ) {
      videoUrl = `${BASE_URL}/workflow/viewUploadedDocument/${currentSubWorkFlowId}/${name}/${
        videoObject?.encrypted_filename
      }${isMapper ? `/${form_field_items}` : ""}`;
    }
  }
  const getTime = useCallback((milliseconds) => {
    let m = moment.utc(milliseconds);
    let mins = m.minutes();
    let secs = m.seconds();
    return `${mins < 10 ? `0${mins}` : mins} : ${
      secs < 10 ? `0${secs}` : secs
    }`;
  }, []);

  const handlePlayVideo = (newTime) => {
    const seconds = newTime / 1000;
    setCurrentTime(seconds);
  };

  const playVideo = () => {
    videoEle.play();
    playBtn.classList.add("d-none");
  };

  const pauseVideo = () => {
    videoEle.pause();
    playBtn.classList.remove("d-none");
  };

  return (
    <>
      <VideoViewer
        label={document_label}
        selectedData={selectedData}
        name={document_name}
        isMapper={isMapper}
        documentData={documentData}
        form_field_items={form_field_items}
      />
      <div className="col-lg-6 col-md-12 col-sm-12">
        <div className="bg-primary-grey-1 p-3 h-100 rounded-3">
          <span className="fs-15px fw-bold">Liveness Detection</span>
          <div className="fs-15px d-flex align-items-center">
            <span
              className="text-primary"
              style={{
                cursor: "pointer",
              }}
              onClick={() => handlePlayVideo()}
            >
              {/* {moment(callbackData?.dkyc_questions_info?.dkyc_questions_time[index]).format("hh:mm")} */}
              ({getTime(4000)})
            </span>

            <span className="ms-3 d-flex align-items-center">
              {selectedData?.verification_response?.[name]?.direction}
              <span className="d-flex ms-2 mb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="tick"
                  width="13.858"
                  height="13.858"
                  viewBox="0 0 13.858 13.858"
                >
                  <g id="Group_3841" data-name="Group 3841">
                    <circle
                      id="Ellipse_274"
                      data-name="Ellipse 274"
                      cx="6.19"
                      cy="6.19"
                      r="6.19"
                      transform="translate(0.739 0.739)"
                      fill="#92ce6a"
                    />
                    <path
                      id="Path_4603"
                      data-name="Path 4603"
                      d="M6.929,13.858a6.929,6.929,0,1,1,6.929-6.929A6.937,6.937,0,0,1,6.929,13.858Zm0-12.785a5.856,5.856,0,1,0,5.856,5.856A5.862,5.862,0,0,0,6.929,1.073Z"
                      fill="#92ce6a"
                    />
                  </g>
                  <path
                    id="Path_4604"
                    data-name="Path 4604"
                    d="M134.8,167.364a.582.582,0,0,1-.416-.174L132.234,165a.583.583,0,0,1,.832-.818l1.719,1.747,3.557-3.917a.583.583,0,1,1,.863.784l-3.971,4.374a.583.583,0,0,1-.42.191Z"
                    transform="translate(-128.782 -157.665)"
                    fill="#fff"
                  />
                </svg>
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default LivenessDetection;
